import { RequestActions } from '../../core/api/state';
import type { ImageAOI } from '../../core/models/imageAssets';
import type { CatalogOptions } from './models';

const actions = {
  LOAD_ASSETS: new RequestActions('[Image Assets] Load assets'),
  LOAD_DRONE_ASSETS: new RequestActions('[Image Assets] Load drone assets'),
  SET_DRONE_STATUS: '[Image Assets] Set drone status',
  SET_S2B_IMAGE_EXCLUSION_ENABLED: '[Image Assets] Set Sentinel-2B image exclusion enabled',
  SET_SELECTED_SCENE_GROUP_ID: '[Image Assets] Set selected scene group ID',
  SET_SELECTED_IMAGES: '[Image Assets] Set selected images',
  SET_SIDE_SELECTED_SCENE_GROUP_ID: '[Image Assets] Set side selected scene group ID',
  SET_SIDE_SELECTED_IMAGES: '[Image Assets] Set side selected images',

  SET_SELECTED_SIDE_ASSETS: '[Image Assets] Set selected side assets',
  SET_DATE_RANGE: '[Image Assets] Set date range',
  SET_DATE_RANGE_REPORT: '[Image Assets] Set date range report',
  SET_CATALOG_OPTIONS: '[Image Assets] Set catalog options',
  SET_CATALOG_OPTIONS_SIDE: '[Image Assets] Set catalog options side',
  SET_IMAGE: new RequestActions('[Image Assets] Set Image'),
  SET_IMAGE_ASSETS_PAGE: '[Image Assets] Set Image Assets Page',
  SET_ASSETS_CURSOR: '[Image Assets] Map load more has cursor for next page',
  LOAD_COMPOSITION: new RequestActions('[Image Assets] Load selected asset group composition'),
  LOAD_SIDE_COMPOSITION: new RequestActions(
    '[Image Assets] Load side selected asset group composition'
  ),
  UPDATE_ASSET_GROUP_COMPOSITION: '[Image Assets] Update selected asset group composition',
  RESET: '[Image Assets] Reset',
  setS2BImageExclusionEnabled: (enabled: boolean) => ({
    type: actions.SET_S2B_IMAGE_EXCLUSION_ENABLED,
    payload: enabled,
  }),
  setSelectedSceneGroup: (id: string | null) => ({
    type: actions.SET_SELECTED_SCENE_GROUP_ID,
    payload: id,
  }),
  setSideSelectedSceneGroup: (id: string | null) => ({
    type: actions.SET_SIDE_SELECTED_SCENE_GROUP_ID,
    payload: id,
  }),
  setSelectedImages: (images: ImageAOI[]) => ({
    type: actions.SET_SELECTED_IMAGES,
    payload: images,
  }),
  setSideSelectedImages: (images: ImageAOI[]) => ({
    type: actions.SET_SIDE_SELECTED_IMAGES,
    payload: images,
  }),
  setCatalogOptions: (options: CatalogOptions) => ({
    type: actions.SET_CATALOG_OPTIONS,
    payload: options,
  }),
  setCatalogOptionsSide: (optionsSide: CatalogOptions) => ({
    type: actions.SET_CATALOG_OPTIONS_SIDE,
    payload: optionsSide,
  }),
  setImageAssetsPage: (page: number) => ({
    type: actions.SET_IMAGE_ASSETS_PAGE,
    payload: page,
  }),
  updateAssetGroupComposition: (id: string, referenceImage: ImageAOI, isSide: boolean) => ({
    type: actions.UPDATE_ASSET_GROUP_COMPOSITION,
    payload: {
      id,
      referenceImage,
      isSide,
    },
  }),
  setAssetsCursor: (page: boolean) => ({
    type: actions.SET_ASSETS_CURSOR,
    payload: page,
  }),
  setDroneStatus: (status: boolean) => ({
    type: actions.SET_DRONE_STATUS,
    payload: status,
  }),
};

export default actions;
